var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 960) scale(1, -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M860.16 444.238c0 194.413-155.921 351.922-348.16 351.922s-348.16-157.508-348.16-351.922c0-194.406 155.925-351.922 348.16-351.922s348.16 157.516 348.16 351.922zM901.12 444.238c0-216.935-174.169-392.882-389.12-392.882s-389.12 175.947-389.12 392.882c0 216.943 174.166 392.882 389.12 392.882s389.12-175.939 389.12-392.882zM532.48 435.64l105.814 99.12c7.876 7.378 20.126 7.378 28.002 0l3.34-3.129c8.255-7.733 8.678-20.693 0.946-28.948-0.305-0.325-0.62-0.641-0.946-0.946l-136.531-127.893c-3.287-3.079-7.337-4.874-11.512-5.382-2.862-1.52-6.127-2.381-9.594-2.381-11.311 0-20.48 9.169-20.48 20.48v245.76c0 11.311 9.169 20.48 20.48 20.48s20.48-9.169 20.48-20.48v-196.68z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessing);
export default __webpack_public_path__ + "static/media/processing.cd8a18df1cf042bd3ef290b797e57b45.svg";
export { ForwardRef as ReactComponent };